import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Star, Trash2 } from "lucide-react";
import { api, fileUrl, formatApiError } from "../../lib/api";
import ImageUploader from "../../components/ImageUploader";

export default function AdminGallery() {
  const [items, setItems] = useState(null);
  const [newImages, setNewImages] = useState([]);
  const [caption, setCaption] = useState("");

  const load = () => api.get("/admin/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!newImages.length) { toast.error("Ajoutez d'abord une photo"); return; }
    try {
      for (const img of newImages) {
        await api.post("/admin/gallery", { image: img, caption, order: (items?.length || 0) + 1 });
      }
      toast.success("Photo(s) ajoutée(s) à la galerie");
      setNewImages([]);
      setCaption("");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const setMain = async (g) => {
    await api.put(`/admin/gallery/${g.id}`, { image: g.image, caption: g.caption, order: g.order, is_main: true });
    toast.success("Photo principale définie");
    load();
  };

  const remove = async (g) => {
    if (!window.confirm("Retirer cette photo de la galerie ?")) return;
    await api.delete(`/admin/gallery/${g.id}`);
    toast.success("Photo supprimée");
    load();
  };

  return (
    <div data-testid="admin-gallery-page">
      <h1 className="font-display text-2xl font-extrabold text-slate-900">Galerie magasin</h1>
      <p className="mt-1 text-xs text-slate-500">Les photos s'affichent sur la page Galerie du site. La « principale » pourra servir de photo de vitrine.</p>

      <div className="card-oxy mt-5 p-5">
        <h2 className="font-display font-bold text-slate-900">Ajouter des photos</h2>
        <div className="mt-3">
          <ImageUploader images={newImages} onChange={setNewImages} max={4} />
        </div>
        <input data-testid="gallery-caption-input" value={caption} onChange={(e) => setCaption(e.target.value)}
          placeholder="Légende (optionnel)" className="input-oxy mt-3" />
        <button data-testid="gallery-add-btn" onClick={add} className="btn-gold mt-4 w-full !py-2.5 text-sm sm:w-auto">Ajouter à la galerie</button>
      </div>

      {items === null ? (
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">{Array.from({ length: 4 }).map((_, i) => <div key={i} className="aspect-square animate-pulse rounded-2xl bg-slate-100" />)}</div>
      ) : items.length === 0 ? (
        <p className="mt-6 rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-500" data-testid="gallery-empty">Galerie vide pour le moment.</p>
      ) : (
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="admin-gallery-grid">
          {items.map((g) => (
            <div key={g.id} data-testid={`admin-gallery-item-${g.id}`} className="card-oxy overflow-hidden">
              <div className="relative aspect-square">
                <img src={fileUrl(g.image)} alt={g.caption || ""} className="h-full w-full object-cover" />
                {g.is_main && (
                  <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-gold px-2 py-0.5 text-[10px] font-bold uppercase text-ink">
                    <Star className="h-3 w-3" /> Principale
                  </span>
                )}
              </div>
              <div className="flex items-center justify-between gap-1 p-2">
                <button data-testid={`gallery-main-${g.id}`} onClick={() => setMain(g)} disabled={g.is_main}
                  className="rounded-lg bg-slate-100 px-2.5 py-1.5 text-[11px] font-bold text-slate-600 hover:bg-gold-soft hover:text-gold-dark disabled:opacity-40">
                  Principale
                </button>
                <button data-testid={`gallery-delete-${g.id}`} onClick={() => remove(g)}
                  className="rounded-lg bg-slate-100 p-2 text-slate-500 hover:bg-red-100 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
